import { useContext } from "react";
import { FiLock } from "react-icons/fi";

import { CalendarContext } from "src/contexts/calendar.context";

import "../calendar.style.scss";

const YearView = () => {
	const { shownYear, shownYearsInterval, changeYear } = useContext(CalendarContext);

	const handleClick = (year) => {
		changeYear(year);
	};

	return (
		<div className="year-view-wrapper">
			{Array.from(Array(12)).map((_, index) => {
				const year = shownYearsInterval[0] + index;
				const locked = shownYear > year;
				// const locked = lockedYears.indexOf(year) != -1;
				return (
					<div
						key={index}
						onClick={() => {
							handleClick(year);
						}}
						className={`year 
						${year == shownYear && "selected"}
						${year > shownYearsInterval[1] && "disabled"}
						${locked && "locked"}
						`}
					>
						{year}
						{locked && <FiLock className="lock-icon" />}
					</div>
				);
			})}
		</div>
	);
};

export default YearView;
